import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import BookDetailDownload from '@/components/screens/book-detail-download/BookDetailDownload';
import { API_URL } from '@/helpers/variables';
import { IBookShortDetail } from '@/interfaces/bookShortDetail.interface';

interface IBookDetailPage {
  book: IBookShortDetail;
}

const BookDetailDownloadPage: NextPage<IBookDetailPage> = ({ book }) => {
  return <BookDetailDownload book={book} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { bookAlias, alias } = context.query;

  const [bookRes] = await Promise.all([fetch(`${API_URL}satellite/books/kuchaknig/${bookAlias}?author_id_or_alias=${alias}`), fetch(`${API_URL}satellite/custom-popular-books/?book_alias=${bookAlias}`)]);
  const [book] = await Promise.all([bookRes.json()]);

  // Check Fetched Data Error
  if (!book.id || book.author.alias !== alias) {
    return {
      notFound: true,
    };
  }

  return { props: { book } };
};

export default BookDetailDownloadPage;
